import { render, staticRenderFns } from "./BaseSidebarOpenButton.vue?vue&type=template&id=5e6d34e3"
import script from "./BaseSidebarOpenButton.vue?vue&type=script&lang=ts"
export * from "./BaseSidebarOpenButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports